import hres88eLabels from 'assets/labels/hres88e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres88eLabels
    }
  },
  index () {
    let mockRows = []
    const mockCodpos = {
      '1': 'Managing Director',
      '2': 'Customer Support',
      '3': 'System Engineer',
      '4': 'Senior System Analyst',
      '5': 'Staff Officer'
    }
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        staappr: staappr,
        dtereq: moment(faker.date.past()).format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        desc_codcomp: 'บริษัท พีเพิล พลัส ซอฟต์แวร์ จำกัด',
        desc_codpos: mockCodpos[Math.floor(Math.random() * 5)],
        status: mockStatus[staappr],
        remarkap: 'Test HRES88E',
        desc_codappr: faker.name.findName(),
        next_codappr: faker.name.findName(),
        v_codapp: 'TJS00001',
        codpos: '0001',
        codcomp: 'TJS'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  create () {
    let mockTab1 = {
      dtereq: '',
      numseq: '',
      codcomp: '',
      desc_codcomp: '',
      numreqst: '',
      codpos: '',
      desc_codpos: '',
      codjob: '',
      desc_codjob: '',
      codempmt: '',
      desc_codempmt: '',
      qtyreq: '',
      dtereqm: '',
      v_year: '',
      v_mth: '',
      amtincom: '',
      codrearq: '',
      type: '',
      v_syncond1: '',
      v_syncond: {
        code: '',
        description: ''
      },
      flgjob: '',
      flgcond: '',
      flgrecut: '',
      desnote: '',
      staappr: ''
    }
    return mockTab1
  },
  detail () {
    let mockTab1 = {
      dtereq: '',
      numseq: faker.random.number().toString().substr(0, 1),
      codcomp: '',
      desc_codcomp: '',
      numreqst: '',
      codpos: '',
      desc_codpos: '',
      codjob: '',
      desc_codjob: '',
      codempmt: '',
      desc_codempmt: '',
      qtyreq: '',
      dtereqm: '22/03/2018',
      v_year: '',
      v_mth: '',
      amtincom: '',
      codrearq: '',
      type: '',
      v_syncond1: '',
      v_syncond: {
        code: '',
        description: ''
      },
      flgrecut: '',
      flgjob: '',
      flgcond: '',
      desnote: '',
      staappr: 'Y'
    }

    return mockTab1
  },
  dropdowns () {
    const mockCodrearq = {
      '1': 'ใหม่',
      '2': 'เพิ่ม',
      '3': 'แทน',
      '4': 'อื่นๆ'
    }

    return {
      codrearq: {
        en: mockCodrearq,
        th: mockCodrearq
      }
    }
  },
  listFields () {
    let mockRowsEn = [
      { code: 'codempid', description: 'Employee Code', type: 'varchar2' },
      { code: 'numlvl', description: 'Number Level', type: 'number' },
      { code: 'codpos', description: 'Position Code', type: 'varchar2' },
      { code: 'dtestrt', description: 'Start Date', type: 'date' }
    ]

    let mockRowsTh = [
      { code: 'codempid', description: 'รหัสพนักงาน', type: 'varchar2' },
      { code: 'numlvl', description: 'ระดับ', type: 'number' },
      { code: 'codpos', description: 'รหัสตำแหน่ง', type: 'varchar2' },
      { code: 'dtestrt', description: 'วันที่เริ่มต้น', type: 'date' }
    ]

    return {
      en: mockRowsEn,
      th: mockRowsTh
    }
  },
  detailCodjob () {
    let mockCodjob = faker.name.jobTitle()

    return {
      syncond: mockCodjob
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres88e/mocker.js